<template>
  <div>
    <div class="table-responsive mt20">
        <div :id="getId" v-show="dataSet.length > 0"></div>
        <div class="alert alert-info" v-show="dataSet.length == 0">
            <i class="icon-info"></i> Aucun résultat.
        </div>
    </div>
  </div>
</template>

<script>

  export default {
    created () {
    },
    props: ["dataSet","columns","order","id"],
    data(){
      return{
      }
    },
    mounted:function(){
      this.createDataTable();
    },
    watch:{
      'columns':function(){
        if(this.dataSet && this.dataSet.length > 0 && this.columns){
          if(this.dataSet[0].length == this.columns.length){
            this.createDataTable();
          }
        }
      }
    },
    computed:{
      getId: function(){
        if(!this.id){
          return "table-parent";
        }
        return this.id;
      }
    },
    methods:{
      createDataTable(){
        var parent = this;
        if(parent.dataSet.length > 0){
            var id2 = "table-"+this.getId;
            $("#"+this.getId).html('<table id="'+id2+'" class="table" style="width:100%"></table>');
            var order = this.order ? [this.order] : [];
            $('#'+id2).DataTable({
                data: parent.dataSet,
                columns: parent.columns,
                "order": order,
                "language": {
                    "emptyTable":     "Aucun résultat",
                    "info":           "Afficher de _START_ à _END_ sur _TOTAL_ résultats",
                    "infoEmpty":      "Aucun résultat",
                    "infoFiltered":   "(filtrés parmis _MAX_ résultats)",
                    "infoPostFix":    "",
                    "thousands":      ",",
                    "lengthMenu":     "Afficher _MENU_ résultats",
                    "loadingRecords": "Chargement...",
                    "processing":     "Calcul...",
                    "search":         "Rechercher : ",
                    "zeroRecords":    "Aucun résultat trouvé.",
                    "paginate": {
                        "first":      "Premier",
                        "last":       "Dernier",
                        "next":       "Suivant",
                        "previous":   "Précédent"
                    },
                    "aria": {
                        "sortAscending":  ": Trie ascendant",
                        "sortDescending": ": Trie descendant"
                    }
                },
                "createdRow": function( row, data, dataIndex ) {

                  for(var d=0;d<data.length;d++){
                    if(data[d].toString().indexOf("tr-green") >= 0){
                      $(row).addClass('th-green');
                    }
                    if(data[d].toString().indexOf("tr-green-light") >= 0){
                      $(row).addClass('th-green-light');
                    }
                    if(data[d].toString().indexOf("colspan-") >= 0){
                      var childrens = $(row).children();
                      var index = data[d].toString().indexOf("colspan-");
                      var nb = parseInt(data[d].toString().substring(index+8));
                      if(Number.isInteger(nb)){
                        $(childrens[d]).attr("colspan",nb);
                        for(var i=1;i<nb;i++){
                          $(childrens[d+i].remove())
                        }
                      }

                    }
                  }
                }
            });


            $.fn.dataTable.ext.errMode = 'none';

            $('#'+id2).on('error.dt', function ( e, settings, techNote, message ) {
              console.error( 'An error has been reported by DataTables: ', message );
            })

        }
        else
        $("#"+this.getId).html('');
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// list.vue?b1e91050